
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Link } from "react-router-dom";
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

import SEO from "../components/SEO";
import TravelAgencySchema from "../components/TravelAgencySchema";
import LocalBusinessSchema from "../components/LocalBusinessSchema";
import ServiceSchema from "../components/ServiceSchema";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import FAQSchema from "../components/FAQSchema";

function Sevntinseater() {



    const cardData =
    {
        keyword: '17 Seater Bus on Rent Pune',
        heading: 'Amruta Travels: 17 Seater Bus on Rent Pune',
        headingDescription: 'Amruta Travels offers 17 Seater Bus on Rent in Pune, perfect for comfortable and efficient group travel across the city or outstation. Whether you’re planning a family function, corporate event, religious trip, school picnic, or airport transfer, our 17-seater buses provide the ideal blend of space, comfort, and reliability.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

   "services": [
    {
      "name": "17 Seater Bus on Rent Pune",
      "description": "Amruta Travels offers 17-seater buses for rent in Pune, ideal for group trips, corporate outings, family vacations, and more. Our buses provide comfort, space, and air conditioning for a smooth journey."
    },
    {
      "name": "17 Seater Bus on Rent in Pune Price",
      "description": "The cost of renting a 17-seater bus in Pune varies based on distance, duration, and the type of bus. Contact Amruta Travels for competitive pricing and customized packages suited to your travel needs."
    },
    {
      "name": "17 Seater Bus Rate per Km in Pune",
      "description": "Amruta Travels offers affordable rates for 17-seater bus rentals in Pune, with pricing based on distance traveled. For specific rates, please contact us to receive a quote tailored to your trip."
    },
    {
      "name": "17 Seater Bus on Rent in Pune",
      "description": "Rent a 17-seater bus for your group outings with Amruta Travels. We provide well-maintained buses for local and outstation trips with professional drivers to ensure a hassle-free experience."
    },
    {
      "name": "17 Seater AC Tempo Traveller On Rent in Pune",
      "description": "For a comfortable and air-conditioned journey, rent a 17-seater AC Tempo Traveller from Amruta Travels. Perfect for long trips, corporate outings, and group travel, our AC Tempo Travellers offer a smooth and comfortable ride."
    },
    {
      "name": "17 Seater Non-AC Tempo Traveller on Rent in Pune",
      "description": "Amruta Travels offers non-AC 17-seater Tempo Travellers for those looking for budget-friendly transportation. Perfect for short trips, our non-AC vehicles offer ample space and comfort."
    },
    {
      "name": "17 Seater Tempo Traveller for Mahabaleshwar from Pune",
      "description": "Rent a 17-seater Tempo Traveller for your trip to Mahabaleshwar from Pune. Our comfortable vehicles ensure a relaxing ride with ample space for everyone in your group. Ideal for family outings or corporate trips."
    },
    {
      "name": "17 Seater Tempo Traveller for Pune to Goa",
      "description": "Travel in style and comfort with a 17-seater Tempo Traveller from Pune to Goa. Whether you're planning a group vacation or corporate retreat, our Tempo Travellers provide the ideal solution for long-distance travel."
    },
    {
      "name": "17 Seater Tempo Traveller Pune to Nashik",
      "description": "Explore Nashik comfortably with a 17-seater Tempo Traveller from Pune. Amruta Travels provides spacious vehicles for smooth journeys, perfect for group travel to destinations like Nashik."
    },
    {
      "name": "17 Seater Tempo Traveller Pune to Mumbai Rent",
      "description": "Rent a 17-seater Tempo Traveller for your journey from Pune to Mumbai. Our buses are designed for comfort, with ample space and professional drivers ensuring a safe, reliable trip."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Hadapsar",
      "description": "If you're based in Hadapsar and need a 17-seater Tempo Traveller, Amruta Travels provides rental services for local and outstation trips. Our vehicles are comfortable, safe, and perfect for group travel."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
      "description": "For group trips in and around Pimpri Chinchwad, rent a 17-seater Tempo Traveller from Amruta Travels. Our vehicles are equipped with air conditioning and are available for both local and outstation journeys."
    },
    {
      "name": "17 Seater Tempo Traveller Hire in Viman Nagar",
      "description": "Looking for a 17-seater Tempo Traveller in Viman Nagar? Amruta Travels provides well-maintained vehicles for comfortable travel. Ideal for both short and long trips, our Tempo Travellers are available with professional drivers."
    },
    {
      "name": "Pune to Shirdi 17 Seater Bus Booking",
      "description": "Book a 17-seater bus for your trip from Pune to Shirdi with Amruta Travels. Our buses offer air-conditioned comfort, space for your group, and a professional driver to ensure a smooth and timely journey to the holy city."
    }
  ],
  "tableData": [
    ["17 Seater Bus on Rent Pune", "17 Seater Bus on Rent in Pune Price"],
    ["17 Seater Bus Rate per Km in Pune", "17 Seater Bus on Rent in Pune"],
    ["17 Seater AC Tempo Traveller On Rent in Pune", "17 Seater Non-AC Tempo Traveller on Rent in Pune"],
    ["17 Seater Tempo Traveller for Mahabaleshwar from Pune", "17 Seater Tempo Traveller for Pune to Goa"],
    ["17 Seater Tempo Traveller Pune to Nashik", "17 Seater Tempo Traveller Pune to Mumbai Rent"],
    ["17 Seater Tempo Traveller on Rent in Hadapsar", "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad"],
    ["17 Seater Tempo Traveller Hire in Viman Nagar", "Pune to Shirdi 17 Seater Bus Booking"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious 17 Seater Bus Rentals in Pune",
    "WhyChoosedescription": "Amruta Travels offers 17 seater buses for rent in Pune, providing an ideal solution for small to medium-sized group travel. Whether you're planning a family trip, corporate outing, or a wedding transportation service, our 17-seater buses offer ample space and comfort for your group’s travel needs."
  },
  {
    "WhyChooseheading": "Perfect for Family, Corporate, and Group Outings",
    "WhyChoosedescription": "Our 17-seater buses are perfect for family gatherings, corporate events, group excursions, and local tours. With comfortable seating, air conditioning, and ample space for luggage, your group will enjoy a smooth and enjoyable ride for both short and long-distance journeys."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for 17 Seater Rentals",
    "WhyChoosedescription": "We offer competitive, affordable, and transparent pricing for 17-seater bus rentals in Pune. Our all-inclusive rates cover fuel, tolls, driver fees, and taxes, with no hidden charges, ensuring that you can plan your budget with complete confidence."
  },
  {
    "WhyChooseheading": "Comfort and Luxury with Modern Amenities",
    "WhyChoosedescription": "Our 17-seater buses are equipped with modern amenities such as air conditioning, comfortable seating, entertainment systems, and ample legroom. These features ensure that your group enjoys a relaxed, comfortable, and enjoyable journey to any destination, whether it’s a local trip or a longer journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Reliable Travel",
    "WhyChoosedescription": "Our 17-seater buses are driven by experienced, professional drivers who prioritize safety and comfort. They are well-versed in navigating Pune’s roads and highways, ensuring that your group arrives on time and safely at your destination."
  },
  {
    "WhyChooseheading": "Ideal for Short and Long-Distance Travel",
    "WhyChoosedescription": "Our 17-seater buses are perfect for both short and long-distance travel. Whether you’re traveling within Pune or going on a day trip to nearby destinations, our buses ensure your group travels in comfort and arrives at your destination without any hassle."
  },
  {
    "WhyChooseheading": "Convenient Online Booking for 17 Seater Rentals",
    "WhyChoosedescription": "Booking a 17-seater bus rental in Pune is easy and convenient with Amruta Travels. You can book your vehicle online, get an instant quote, and confirm your booking quickly. We also offer flexible rental durations to suit your travel needs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Travel Experience",
    "WhyChoosedescription": "Amruta Travels provides round-the-clock customer support to ensure that your booking process is smooth and your trip is hassle-free. Our team is always available to assist you with any inquiries or last-minute changes, providing a seamless travel experience from start to finish."
  }
]






















    }

const faqData = [
  {
    question: 'Can I rent a mini bus with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers mini buses for rent, perfect for group transportation. Whether you need it for a family trip, corporate event, or school outing, our mini buses provide comfort, safety, and convenience.',
  },
  {
    question: 'What are the seating capacities available for mini buses on rent?',
    answer: 'Our mini buses come in various seating configurations, including 16-seater, 20-seater, 24-seater, and 30-seater, ensuring a comfortable ride for both small and larger groups.',
  },
  {
    question: 'Is a driver included with the mini bus rental?',
    answer: 'Yes, all mini bus rentals come with a professional and experienced driver. Our drivers are trained to provide a safe and smooth travel experience, ensuring your journey is stress-free.',
  },
  {
    question: 'How much does it cost to rent a mini bus?',
    answer: 'The cost of renting a mini bus depends on factors such as the seating capacity, trip duration, and distance. We provide competitive rates and can offer customized quotes based on your specific requirements. Contact us for more details.',
  },
  {
    question: 'Can I rent a mini bus for both local and outstation trips?',
    answer: 'Yes, our mini buses are available for both local trips within the city and outstation journeys to popular destinations. Whether it’s a day trip or a longer excursion, we ensure a comfortable ride.',
  },
  {
    question: 'Are the mini buses well-maintained and sanitized?',
    answer: 'Yes, all our mini buses are regularly serviced and thoroughly sanitized before every trip to ensure the highest standards of hygiene and comfort.',
  },
  {
    question: 'Can I book a mini bus online?',
    answer: 'Yes, you can easily book a mini bus through our website or by contacting our customer support team. We will guide you through the booking process and provide all the necessary details.',
  },
  {
    question: 'What types of events can I rent a mini bus for?',
    answer: 'Our mini buses are perfect for a wide range of events, including corporate outings, family gatherings, weddings, school trips, group tours, and airport transfers. They provide a comfortable and convenient way to travel with a group.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    role: 'Marketing Head, Pune',
    text: 'We rented a 24-seater mini bus for a corporate event. The vehicle was spacious, clean, and well-maintained. The driver was punctual and professional. Amruta Travels provided an excellent experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    role: 'Event Organizer, Pune',
    text: 'I rented a mini bus for a family trip, and the service was outstanding. The vehicle was comfortable, and the driver made sure everything went smoothly. Highly recommend Amruta Travels for group travel!',
    rating: 5,
  },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
{
    src: "/images/gallery/24.jpg",
    alt: "17 Seater Bus On Rent in Pune by Amruta Travels"
},
{
    src: "/images/gallery/28.jpg",
    alt: "17 Seater AC Bus Hire in Pune"
},
{
    src: "/images/gallery/2.jpg",
    alt: "Luxury 17 Seater Bus Rental Pune"
},
{
    src: "/images/gallery/3.jpg",
    alt: "Corporate 17 Seater Bus Hire in Pune"
},
{
    src: "/images/gallery/24.jpg",
    alt: "Wedding 17 Seater Bus Rental Pune"
},
{
    src: "/images/gallery/27.jpg",
    alt: "Mini Bus Hire Pune for Family Trips"
},
{
    src: "/images/gallery/29.jpg",
    alt: "Outstation 17 Seater Bus Rental from Pune"
},
{
    src: "/images/gallery/30.jpg",
    alt: "17 Seater Tourist Bus Hire in Pune"
},
{
    src: "/images/gallery/31.jpg",
    alt: "Amruta Travels 17 Seater Bus Fleet Pune"
},
];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/17-seater-bus-on-rent.jpg",
  "description": "Book a 17 Seater Bus on Rent in Pune with Amruta Travels for corporate travel, weddings, family trips, airport transfers and outstation tours across Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/17-seater-bus-on-rent"
  }
};



    return (
    <div>

        <TravelAgencySchema />

        <ServiceSchema
            serviceType="17 Seater Bus On Rent in Pune"
            url="https://bushireinpune.com/17-seater-bus-on-rent-in-pune"
            description="Book a 17 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate travel, airport transfers, employee transport and outstation tours."
        />

        <BreadcrumbSchema
            pageName="17 Seater Bus On Rent in Pune"
            pageUrl="https://bushireinpune.com/17-seater-bus-on-rent-in-pune"
        />

        <FAQSchema faqs={faqData} />

<SEO
  title="17 Seater Bus On Rent in Pune | AC Mini Bus Hire | Amruta Travels"
  description="Book a 17 Seater Bus On Rent in Pune with Amruta Travels. Ideal for corporate events, weddings, family trips, airport transfers and outstation tours. Professional drivers, clean AC buses and affordable prices."
  canonical="https://bushireinpune.com/17-seater-bus-on-rent-in-pune"
  image="https://bushireinpune.com/assets/images/17-seater-bus-on-rent.jpg"
  schema={[
    productSchema
  ]}
/>

<LocalBusinessSchema />

<section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
    17 Seater Bus On Rent in Pune
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/77.jpg"
    alt="17 Seater Bus On Rent in Pune by Amruta Travels"
    loading="eager"
    fetchPriority="high"
    width="900"
    height="500"
/>
                            <h2 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h2><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>
  {service.description}

  {index === 0 && (
    <>
      {" "}
      Looking for a larger vehicle? Explore our{" "}
      <Link to="/22-seater-bus-on-rent-in-pune">
        22 Seater Bus on Rent in Pune
      </Link>
      {" "}or{" "}
      <Link to="/32-seater-bus-on-rent-in-pune">
        32 Seater Bus on Rent in Pune
      </Link>
      {" "}services.
    </>
  )}

  {index === 3 && (
    <>
      {" "}
      We also provide{" "}
      <Link to="/45-seater-bus-on-rent-in-pune">
        45 Seater Bus on Rent in Pune
      </Link>
      {" "}for larger groups.
    </>
  )}

  {index === 5 && (
    <>
      {" "}
      If you need premium vehicles, check our{" "}
      <Link to="/force-urbania-on-rent-pune">
        Force Urbania on Rent in Pune
      </Link>.
    </>
  )}
</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />
<div className="my-5">
    <h2>17 Seater Bus Specifications</h2>

    <table className="table table-bordered">
        <tbody>
            <tr>
                <th>Seating Capacity</th>
                <td>17 Passengers</td>
            </tr>

            <tr>
                <th>Air Conditioning</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Pushback Seats</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Music System</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Charging Points</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Luggage Space</th>
                <td>Large</td>
            </tr>

            <tr>
                <th>Driver Included</th>
                <td>Yes</td>
            </tr>

            <tr>
    <th>Suitable For</th>
    <td>
        Corporate Events, Weddings, Airport Transfers,
        Family Trips, School Picnic,
        Religious Tours,
        Pune to Shirdi,
        Pune to Mahabaleshwar,
        Pune to Goa,
        Outstation Travel
    </td>
</tr>
        </tbody>
    </table>
    <div className="alert alert-primary my-4">

<h3>Need a 17 Seater Bus on Rent in Pune?</h3>

<p>
Call <a href="tel:+917353109555">+91 7353109555</a>
for instant booking. We provide AC and Non-AC
17 Seater Bus rentals for weddings,
corporate travel,
airport pickup,
family trips,
school tours,
and outstation travel across Maharashtra.
</p>

</div>
</div>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>
<section className="my-5">
  <h2>Related Bus Rental Services in Pune</h2>

  <div className="row">

    <div className="col-md-4 mb-3">
      <Link
        to="/22-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        22 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/24-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        24 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/26-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        26 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/32-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        32 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/35-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        35 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/40-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        40 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/45-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        45 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/49-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        49 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/50-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        50 Seater Bus on Rent in Pune
      </Link>
    </div>

    <div className="col-md-4 mb-3">
      <Link
        to="/53-seater-bus-on-rent-in-pune"
        className="btn btn-outline-primary w-100"
      >
        53 Seater Bus on Rent in Pune
      </Link>
    </div>

  </div>
</section>

                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <Link
    to="/bus-on-rent-in-pune"
    className="d-flex justify-content-around align-items-center"
>
                                            <div className="b1">
                                                <img
    src={e.place}
    alt={e.text}
    loading="lazy"
    decoding="async"
/>
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <span className="px-3">{e.text}</span>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
    src={image.src}
    alt={image.alt}
    className="gallery-image"
    loading="lazy"
    decoding="async"
    width="400"
    height="300"
/>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Sevntinseater;